export default __webpack_public_path__ + "static/media/030_corner1.first.d4f54ad9.webp";